export default {
    CREATE_SUCCESS(state, val) {
        state.isResponse.code = val;
    },
    CREATE_FAILED(state, val) {
        state.isMsg.message = val;
    }
}